import Predictive from "../assets/Predictive.svg";
import Domain from "../assets/Domain.svg";
import Ecosystem from "../assets/Ecosystem.svg";
import Security from "../assets/Security.svg";

export default function ValueProposition() {
  const features = [
    {
      icon: Predictive,
      title: "Advanced Predictive Analytics",
      description:
        "Leverage generative AI and machine learning to forecast trends and uncover actionable insights. Empower teams to anticipate risks, capture opportunities, and stay competitive.",
    },
    {
      icon: Ecosystem,
      title: "Unified Data Ecosystem",
      description:
        "Integrate and streamline enterprise data for instant access, governance, and analytics. Eliminate silos, improve collaboration, and enhance data-driven growth.",
    },
    {
      icon: Domain,
      title: "Domain-Specific Expertise",
      description:
        "Benefit from analytics frameworks tailored to your sector. Senpiper ensures scalable efficiency with solutions designed for unique industry challenges.",
    },
    {
      icon: Security,
      title: "Compliance and Security",
      description:
        "Protect data with comprehensive security, continuous monitoring, and full regulatory compliance. Our framework ensures trust and transparency.",
    },
  ];

  return (
    <section className="px-4 sm:px-6 md:px-10 lg:px-36 py-12 sm:py-16 lg:py-20 bg-white flex flex-col items-center gap-12 sm:gap-16">
      {/* Header */}
      <div className="max-w-4xl text-center flex flex-col gap-4 sm:gap-6 px-4">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-zinc-700 tracking-wide leading-tight font-['IBM_Plex_Sans']">
          Our Data Analytics Value Proposition
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-gray-700 leading-relaxed tracking-tight font-['Nunito Sans']">
          Senpiper delivers secure, scalable analytics solutions powered by AI and automation.
          We help organizations accelerate digital transformation with actionable insights,
          resilient operations, and measurable growth.
        </p>
      </div>

      {/* Grid Layout for Features */}
      <div className="grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-2 lg:gap-16 xl:gap-24 2xl:gap-x-40 2xl:gap-y-28 pt-4 sm:pt-8 md:pt-10 xl:pt-[72px] 2xl:pt-[102px] md:mx-auto w-full max-w-7xl">
        {features.map((f, i) => (
          <div
            key={i}
            className="w-full max-w-lg mx-auto h-auto min-h-[200px] sm:min-h-[220px] lg:min-h-[240px] p-4 sm:p-6 bg-white rounded-lg outline outline-1 outline-slate-300 
                      flex flex-col justify-start items-start gap-3 sm:gap-4 shadow-sm hover:shadow-md transition"
          >
            {/* SVG icon */}
            <img
              src={f.icon}
              alt={f.title}
              className="w-10 h-10 sm:w-12 sm:h-12 lg:w-[48px] lg:h-[48px] relative"
            />
         
            {/* Title */}
            <h3 className="self-stretch text-blue-900 text-lg sm:text-xl lg:text-2xl font-semibold leading-snug tracking-tight font-['Nunito Sans']">
              {f.title}
            </h3>
         
            {/* Content */}
            <p className="self-stretch text-gray-700 text-sm sm:text-base lg:text-lg font-normal leading-snug tracking-tight font-['Nunito Sans']">
              {f.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
